export const amount = (value: number | null, unit: string | null = null) =>
  value == null ? "Doğrulanamadı" : `${new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 6 }).format(value)}${unit ? ` ${unit}` : ""}`;
export const operatorNumber = (value: number, maximumFractionDigits = 3) =>
  new Intl.NumberFormat("tr-TR", { maximumFractionDigits }).format(value);
export const operatorAmount = (value: number | null, unit: string) =>
  value == null ? "Doğrulanamadı" : unit === "plan birimi"
    ? operatorNumber(value)
    : amount(value, unit);
